import { render, staticRenderFns } from "./loginmethod.vue?vue&type=template&id=522ab8f4&scoped=true"
import script from "./loginmethod.vue?vue&type=script&lang=js"
export * from "./loginmethod.vue?vue&type=script&lang=js"
import style0 from "./loginmethod.vue?vue&type=style&index=0&id=522ab8f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522ab8f4",
  null
  
)

export default component.exports